/* eslint-disable @typescript-eslint/no-unused-vars */
import { Avatar, Flex, Text } from '@chakra-ui/react'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { iCalibracao, iQuestaoCalibracao, iResposta, iRespostaEscala } from '../../../../../interfaces'
import { UpdateElementByPosition } from '../../../../../Utils/Helper'
import { TableDiv } from './styles'

interface iProps {
  itemId: string
  calibracao: iCalibracao
  onChangeCalibracao: (itemId: string, calibracao: iCalibracao) => void
}

export const TabelaCalibracao: React.FC<iProps> = ({ calibracao, onChangeCalibracao, itemId }) => {
  const isSelect = (perguntaId: string, resposId: string, newCalibracao?: iCalibracao): boolean => newCalibracao?.respostas.find(e => e.questaoId === perguntaId && e.respostaId === resposId) !== undefined
  const isSelectQuestao = (perguntaId: string, newCalibracao?: iCalibracao): boolean => newCalibracao?.respostas.find(e => e.questaoId === perguntaId) !== undefined

  function SelResposta(questaoId: string, resposId: string, itemId: string, newCalibracao?: iCalibracao): void {
    if (!newCalibracao) return

    const copyCalibracao = { ...newCalibracao }

    if (!copyCalibracao.participantes.includes(7)) {
      copyCalibracao.participantes = [...copyCalibracao.participantes, 7]
    }

    if (!isSelectQuestao(questaoId, copyCalibracao)) {
      copyCalibracao.respostas = [...copyCalibracao.respostas, { questaoId: questaoId, respostaId: resposId }]
    } else {
      if (!isSelect(questaoId, resposId, copyCalibracao)) {
        copyCalibracao.respostas = UpdateResposta(questaoId, resposId, copyCalibracao)
      }
    }

    const posCompetencia = copyCalibracao.tabela.findIndex(e => e.questoes.some(r => r.idQuestao === questaoId))
    if (posCompetencia !== -1) {
      const posQuestao = copyCalibracao.tabela[posCompetencia].questoes.findIndex(e => e.idQuestao === questaoId)
      if (posQuestao !== -1) {
        const copy = copyCalibracao.tabela[posCompetencia]
        copy.questoes[posQuestao].consolidado = copyCalibracao.escala.find(e => e.id === resposId)?.peso.toFixed(2)
        const sum = copy.questoes.filter(e => e.consolidado).map(e => parseFloat(e.consolidado ?? '0') ?? 0).reduce((a, b) => a + b, 0)
        copy.consolidado = ((sum / copy.questoes.filter(e => e.consolidado).length) || 0).toString()
        copyCalibracao.tabela = UpdateElementByPosition(
          [...copyCalibracao.tabela],
          posCompetencia,
          copy
        )
      }
    }

    onChangeCalibracao(itemId, copyCalibracao)
  }

  function UpdateResposta(questaoId: string, respostaId: string, newCalibracao?: iCalibracao): iResposta[] {
    if (!newCalibracao) return []

    const respostas = [...newCalibracao.respostas]
    const pos = respostas.findIndex(e => e.questaoId === questaoId)
    if (pos !== -1) {
      respostas[pos].respostaId = respostaId
      return respostas
    }

    return []
  }

  return (
    <Flex width={'100%'} flexDir={'column'} gap={'1rem'}>
      <TableDiv>
        <table>
          <thead>
            <tr>
              <th>Questão</th>
              {calibracao.escala.filter(e => e.peso !== -1).map(e => {
                return (
                  <th>
                    {e.resposta.replace(' ', '\n ')}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {calibracao.questoes.sort((a, b) => { return a.competencia.nome.localeCompare(b.competencia.nome) }).map(questao => {
              return (<tr>
                <td style={{ maxWidth: '16rem', minWidth: '9rem' }}>
                  <Flex gap={'.25rem'} flexDir={'column'} alignItems={'start'} justifyContent='center'>
                    <Flex lineHeight={'14px'} gap={'.325rem'} alignItems={'center'}>
                      <Avatar src={questao.competencia.icone} size={'xs'} bg={'var(--c1)'} border={'1px solid var(--Azul)'}/>
                      <Text fontWeight={600} fontSize={'14px'}>{questao.competencia.nome}</Text>
                    </Flex>
                    <Text fontWeight={400} fontSize={'14px'}>{questao.pergunta}</Text>
                  </Flex>
                </td>
                {calibracao.escala.filter(e => e.peso !== -1).map(e => {
                  return (
                    <td>
                      <Flex gap={'.325rem'} width={'7rem'}>
                        <CheckboxCmp isChecked={isSelect(questao.id, e.id, calibracao)} OnChange={(val) => { if (val) { SelResposta(questao.id, e.id, itemId, calibracao) } }}></CheckboxCmp>
                        {questao.respostaColaborador.resposta.id === e.id && <ElementoTooltipCmp label={questao.respostaColaborador.colaborador?.nome} bg={'var(--Azul)'}>
                          <Avatar size={'sm'} src={questao.respostaColaborador?.colaborador?.avatar ?? ''}/>
                        </ElementoTooltipCmp>}
                        {questao.respostaGestor.resposta.id === e.id && <ElementoTooltipCmp label={questao.respostaGestor.colaborador?.nome} bg={'var(--Azul)'}>
                          <Avatar size={'sm'} src={questao.respostaGestor.colaborador?.avatar ?? ''}/>
                        </ElementoTooltipCmp>}
                      </Flex>
                    </td>
                  )
                })}
              </tr>)
            })}
          </tbody>

        </table>
      </TableDiv>
    </Flex>
  )
}
